/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface SearchPlayer200ResponseResultsInner
 */
export interface SearchPlayer200ResponseResultsInner {
    /**
     * 
     * @type {boolean}
     * @memberof SearchPlayer200ResponseResultsInner
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayer200ResponseResultsInner
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayer200ResponseResultsInner
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPlayer200ResponseResultsInner
     */
    number?: string;
}


/**
 * Check if a given object implements the SearchPlayer200ResponseResultsInner interface.
 */
export function instanceOfSearchPlayer200ResponseResultsInner(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function SearchPlayer200ResponseResultsInnerFromJSON(json: any): SearchPlayer200ResponseResultsInner {
    return SearchPlayer200ResponseResultsInnerFromJSONTyped(json, false);
}

export function SearchPlayer200ResponseResultsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPlayer200ResponseResultsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'active': !exists(json, 'active') ? undefined : json['active'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'number': !exists(json, 'number') ? undefined : json['number'],
    };
}

export function SearchPlayer200ResponseResultsInnerToJSON(value?: SearchPlayer200ResponseResultsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'active': value.active,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'number': value.number,
    };
}

